<template>
	<div :class="{ 'v-input--error': error }">
		<div
			v-if="label"
			:class="[$style.text600, 'ao-c4 mb-3']"
		>
			{{ label }}
		</div>
		<div class="d-flex align-center">
			<ao-text-field
				v-if="showInput"
				v-model="inputValue"
				:class="[$style.input, 'mt-n4 mr-2 pt-0 customize-input-icons-small']"
				density="compact"
				color="primary"
				variant="underlined"
				size="small"
				height="28"
				hide-details
				:suffix="componentPayload.appendInner"
			/>
			<v-slider
				:modelValue="modelValue"
				hide-details
				:class="numbered && $style.numbered"
				:color="color"
				:thumb-size="getThumbSize"
				:step="step"
				:min="min"
				:max="max"
				:error="error"
				class="ma-0"
				@update:modelValue="
					(payload) => {
						onUpdate(payload)
					}
				"
			/>
		</div>
		<div class="v-input__details">
			<div class="v-messages">
				<div
					v-if="error && errorMessages"
					class="v-messages__message"
				>
					<span v-if="!Array.isArray(errorMessages)">{{ errorMessages }}</span>
					<span v-else-if="!Array.isArray(errorMessages[0])">{{ errorMessages[0] }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AoSlider',

	props: {
		modelValue: {
			type: Number,
			default: 0,
		},

		label: { type: String, default: '' },

		min: Number,
		max: Number,
		step: { type: Number, default: 1 },

		thumbSize: { type: Number, default: 16 },
		numbered: { type: Boolean, default: false },
		showInput: Boolean,

		color: { type: String, default: 'primary' },

		componentPayload: {
			type: Object,
			default: () => ({}),
		},
		error: { type: Boolean, default: false },
		errorMessages: {
			type: Array || String,
			default: [null],
		},
	},

	emits: ['update:modelValue'],

	data() {
		return {
			inputValue: this.modelValue || this.min,
		}
	},

	computed: {
		getThumbSize() {
			return this.numbered ? 24 : this.thumbSize
		},
	},
	watch: {
		inputValue(val) {
			if (isNaN(val) || val > this.max || val < this.min) {
				return false
			}
			this.inputValue = val || this.min
			this.$emit('update:modelValue', val || this.min)
		},
	},

	methods: {
		onUpdate(num) {
			this.inputValue = num

			this.$emit('update:modelValue', num)
		},
	},
}
</script>

<style module lang="scss">
.text600 {
	color: #86919d;
}

.input {
	flex: unset;
	width: 80px;
}

.numbered {
	:global(.v-slider-thumb:after) {
		content: attr(aria-valuenow);

		position: absolute;
		top: 0;

		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;

		font-family: Inter, sans-serif;
		font-weight: 500;
		font-size: 11px;
		color: white;
	}
}
</style>
